import { PipeTransform } from '@angular/core';
var StrReplacePipe = /** @class */ (function () {
    function StrReplacePipe() {
    }
    StrReplacePipe.prototype.transform = function (value, searchStr, replaceStr) {
        return (value || '').replaceAll(searchStr, replaceStr);
    };
    return StrReplacePipe;
}());
export { StrReplacePipe };
